import type { Context } from '@/overmind';

import type { GUID } from '../auth';

let _identityApi: Context['effects']['api']['identity'] | null = null;
let _applicationId: string | undefined;
export default {
  initialize: (
    identityApi: typeof _identityApi,
    getApplicationId: () => string | undefined
  ) => {
    _identityApi = identityApi;
    _applicationId = getApplicationId();
  },

  async hasAccess(
    tenantId: GUID,
    abortController?: AbortController
  ): Promise<boolean> {
    if (!_identityApi)
      throw new Error('[effect: applicationAccess]: not initialized!');
    const result = await _identityApi.getApplicationsAssignedToTenant(
      tenantId,
      abortController
    );
    if (
      result?.type === 'SUCCESS' &&
      result.context.applications.find(
        application => application.applicationId === _applicationId
      )
    ) {
      return true;
    }

    return false;
  }
};
